import moment from 'moment'
import ReservationModel from 'frontend_core/dist/model/Reservation'
import { getFileName } from 'frontend_core/dist/helpers/format'
import { type PropTypes } from './index'

function getDateText(d: Date): string {
  const today = moment()
  const date = moment(d)
  if (today.diff(date, 'hours') < 24) {
    return i18n.t('page.shared.today')
  }
  if (today.diff(date, 'hours') < 48) {
    return i18n.t('page.shared.yesterday')
  }
  return date.format(i18n.t('page.shared.dateFormat_MD'))
}

function getTimeText(d: Date): string {
  return moment(d).format(i18n.t('page.shared.timeFormatKMM'))
}

function isImageFileName(filename: string): boolean {
  return Boolean(
    (filename || '').toLowerCase().match(/(\.jpg|\.png|\.gif|\.jpeg|\.bmp)$/i),
  )
}

function getFileNameFromUri(uri: string): string {
  const separates = (uri || '').split('?')
  return getFileName(decodeURIComponent(separates[0]))
}

function formatMessagesProps(messages) {
  return messages.map(message => {
    const filename = getFileNameFromUri(message.file)

    const isImage = message.file && isImageFileName(filename)
    const imageProp = isImage && {
      thumbnailUrl: message.file || '',
      src: message.file || '',
      alt: message.content || '',
      filename,
    }

    const isFile = message.file && !isImage
    const fileProp = isFile && {
      fileUrl: message.file || '',
      filename,
    }

    return {
      isSelf: message.from_type === 'User',
      isOpponent: message.from_type !== 'User',
      systemMessage: message.timeline_type === 1 ? message.content : '',
      selfMessage: message.from_type === 'User' ? message.content : '',
      opponentMessage:
        message.from_type === 'Owner' || message.from_type === 'AdminUser'
          ? message.content
          : '',
      iconImage:
        message.from_type === 'Owner' || message.from_type === 'AdminUser'
          ? (message.from || {}).profile_image
          : '',
      read: message.is_read_by_other_side,
      time: getTimeText(message.created_at),
      image: imageProp || null,
      file: fileProp || null,
      receivedAt: moment(message.created_at),
      receivedDateText: getDateText(message.created_at),
    }
  })
}

export default function getReservationMessagesForm(
  reservationDetail: any,
  ui: {
    loading: boolean,
    messagesFetching: boolean,
    messageSending: boolean,
    message: string,
    isShowContentsSp: boolean,
  },
  onReachedTop: Function,
  onRefTopMessageBaloon: Function,
  handleChangeText: Function,
  onClickSend: Function,
  onClickFile: Function,
  onRefInputFile: Function,
  onChangeFile: Function,
): PropTypes {
  const { detail, messages, id } = reservationDetail

  // メッセージ用のデータ整形
  const reservationMessage = {
    show: !reservationDetail.hasMoreData,
    reservationDate: moment(detail.created_at),
    date: getDateText(detail.created_at),
    time: getTimeText(detail.created_at),
    purposeUse: detail.event_type_text,
    utilityForm: [
      '',
      i18n.t('page.shared.usePersonal'),
      i18n.t('page.shared.useBusiness'),
    ][detail.use_type],
    numberOfPeople: detail.capacity
      ? i18n.t('page.shared.unit.personMin', { count: detail.capacity })
      : '-',
    applicationDetail: detail.content,
  }

  return {
    reservationMessage: reservationMessage,
    isInquiry: ReservationModel.isInquiry(detail),
    messages: formatMessagesProps(messages),
    loading: ui.messagesFetching,
    buttonsDisable: ui.messageSending,
    messageText: ui.message,
    onReachedTop,
    onRefTopMessageBaloon,
    handleChangeText: value => handleChangeText('message', value),
    onClickSend,
    onClickFile,
    onRefInputFile,
    onChangeFile,
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationMessagesForm/presenter.js